import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../common/Button";
import { FormInput, FormLayout } from "../common/FormLayout";

export const ForgotPasswordPage = () => {
  const [login, setLogin] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError(null);
    setIsLoading(true);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_URL_SERVER_DATA}/sendmail-to-create-password `,
        {
          method: "POST",
          headers: {
            "Content-type": "application/json",
          },
          body: JSON.stringify({ login }),
        }
      );

      if (response.ok) {
        navigate("/forgot-password/confirmation");
      } else {
        setError("Une erreur est survenue. Veuillez réessayer.");
      }
    } catch (error) {
      setError("Une erreur est survenue. Veuillez réessayer.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <FormLayout title="Réinitialisation du mot de passe">
      <form onSubmit={handleSubmit} className="space-y-6">
        {error && (
          <div className="p-4 bg-red-100 border border-red-400 text-red-700 rounded-lg">
            {error}
          </div>
        )}

        <FormInput
          label="Email"
          type="email"
          value={login}
          onChange={(e) => setLogin(e.target.value)}
          required
          disabled={isLoading}
        />

        <Button
          type="submit"
          size="full"
          disabled={!login || isLoading}
          className={!login || isLoading ? "opacity-50 cursor-not-allowed" : ""}
        >
          {isLoading ? "ENVOI EN COURS..." : "RÉINITIALISER MON MOT DE PASSE"}
        </Button>

        <div className="mt-6 text-center">
          <a href="/login" className="block text-tertiary hover:underline">
            Retour à la connexion
          </a>
        </div>
      </form>
    </FormLayout>
  );
};
